import supabaseClient from '@/api/supabaseClient.ts';
import { PlaceRepository } from '$/repositories/placeRepository/PlaceRepository.ts';

const placeRepository = new PlaceRepository(supabaseClient);
export default placeRepository;

